<template lang="pug">
  e-chart(
    v-if='hasGraph'
    chartId='msn-delta'
    header='Количество необходимых контейнеров'
    :series='series'
    :options='options'
  )
    template(slot="exportData")
      .chart-block__export-data
        div Количество необходимых контейнеров
    template(v-slot:chartHeader)
      div.green-color(v-if='required_volume <= 0') Контейнеров хватает для того чтобы вывозить все отходы
      div.red-color(v-else) Не хватает контейнеров на {{required_volume}} куб.м для того чтобы вывозить все отходы
</template>

<script>
import { analytic } from '@/api/api-endpoints'

export default {
  name: 'msn-delta',
  data: () => ({
    required_volume: null,
    hasGraph: false,
    options: {
      chart: { type: 'bar' },
      title: '',
      yAxis: {
        title: '',
      },
      plotOptions: {},
      credits: {},
    },
    series: [
      {
        name: 'Отходы индивидуальных домовладений и многоквартирных домов, куб.м',
        data: [],
      },
      {
        name: 'Суммарный объём контейнеров, куб.м',
        data: [],
      },
    ],
  }),
  methods: {
    async getMsnDelta() {
      const data = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: analytic.msnDelta(),
        })
      ).data
      this.required_volume = Math.round(data.required_volume)
      this.series[0].data[0] = Number(data.plan_year_volume)
      this.series[1].data[0] = Number(data.fact_year_volume)
      this.hasGraph = true
    },
  },
  created() {
    this.getMsnDelta()
  },
}
</script>
